import { Trans } from '@lingui/react/macro';

import { BackLinkSubheader } from '@/common-components/elements/BackLinkSubheader/BackLinkSubheader';
import routes from '@/routes/routes.constants';

export interface PageHeaderProps {
  onBackClick: () => void;
}

export const PageHeader = ({ onBackClick }: PageHeaderProps) => (
  <>
    <BackLinkSubheader to={routes.AMBIENT} onClick={onBackClick}>
      <Trans>Back to all templates</Trans>
    </BackLinkSubheader>
    <div className="vai-flex-shrink-0 vai-bg-white vai-px-6 vai-py-5">
      <h1 className="vai-text-2xl vai-font-bold vai-text-gray-900">
        <Trans>Template field settings</Trans>
      </h1>
      <p className="vai-mt-1 vai-text-sm vai-text-gray-600">
        <Trans>Configure field values for your procedure note templates.</Trans>
      </p>
    </div>
  </>
);
